import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function lengthValidator(): ValidatorFn {
  return (control: AbstractControl<Array<any>>): ValidationErrors | null => {
    const value = control.value;
    return (Array.isArray(value) && value.length > 0) ? null : { required: true };
  }
}